"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const lab_1 = require("@material-ui/lab");
require("./pagination.scss");
const common_1 = require("../../../utils/common");
const PaginationBlock = (props) => {
    const { changeParams, changeRequest, resetConditions, itemsCount, browserHistoryHandle, removeMutatedBlock } = props;
    const count = Math.ceil(itemsCount / changeParams.limit);
    const [page, setPage] = react_1.useState(parseInt(common_1.urlPrams("page")) || changeParams.offset + 1);
    const nextPageCount = changeParams.limit * page;
    const from = nextPageCount - changeParams.limit + 1;
    const to = (itemsCount - from) < changeParams.limit ? itemsCount : nextPageCount;
    const pagination = react_1.createRef();
    react_1.useEffect(() => {
        const baseUrl = window.location.href.split("?")[0];
        const page = common_1.urlPrams("page");
        const prevPath = localStorage.getItem('prevPath');
        if (page && !prevPath) {
            setPage(1);
            history.pushState(window.location.href, null, `${baseUrl}?page=${1}`);
        }
    }, resetConditions);
    // handle pagination and data update when navigating with browser buttons
    window.onpopstate = (event) => {
        if (common_1.isMobileBrowser().check || common_1.ifMobile()) {
            removeMutatedBlock();
        }
        // prevent sending filter request in other pages
        if ((document.location.href.indexOf('directory') > -1 && changeParams.action === 'directory') ||
            (document.location.href.indexOf('chat') > -1 && changeParams.action === 'chat') ||
            (document.location.href.indexOf('payment-history') > -1 && changeParams.action === 'history')) {
            browserHistoryHandle();
            setPage(parseInt(common_1.urlPrams("page")) || 1);
        }
    };
    // handle page change event
    const handlePage = (e, page) => {
        const parentElement = pagination.current.parentElement;
        window.scrollTo(0, parentElement.offsetTop - 55);
        setPage(page);
        const baseUrl = window.location.href.split("?")[0];
        history.pushState(window.location.href, null, `${baseUrl}?page=${page}`);
        changeRequest(Object.assign(Object.assign({}, changeParams), { offset: page - 1 }));
    };
    return (react_1.default.createElement("div", { ref: pagination, className: "v2-pagination" },
        react_1.default.createElement(lab_1.Pagination, { count: count, shape: "rounded", page: page, onChange: (e, val) => handlePage(e, val) }),
        react_1.default.createElement("span", { className: 'items-counter' },
            from,
            "-",
            to,
            " of ",
            itemsCount)));
};
exports.default = PaginationBlock;
